import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { ChatOutlined } from '@mui/icons-material';
import { DynamicBreadcrumbs } from 'components/Breadcrumb';

export const Chat: React.FC = () => {
    return (
        <Box pl={{ xs: 1.25, md: 2.5 }} pt={1} width="100%" mb={3}>
            <DynamicBreadcrumbs
                items={[
                    { itemPath: '/dashboard', itemLabel: 'Home' },
                    { itemPath: '/support/chat', itemLabel: 'Chat' },
                ]}
            />

            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    mt: 2,
                    textAlign: 'center',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <ChatOutlined sx={{ fontSize: 64, color: 'text.secondary' }} />
                <Typography variant="h5" fontWeight={700}>
                    Chat Support
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Chat with our support team in real-time. This feature is coming soon.
                </Typography>
            </Paper>
        </Box>
    );
};

export default Chat;
